import api from './apiSetup';

export const fetchUserInfo = () => {
  return api('/me');
};

export const fetchPaymentInfo = () => {
  return api('/me/payment-info?user_ip=');
};

export const fetchPurchasedBundles = type => {
  return api(`/me/purchases?type=${type}`);
};
